<div class="layer_details__row left">
  <div class="layer_details__label">Azimuth</div>
  <div class="layer_details__value">{{ azimuth }}°</div>
</div>
<div class="layer_details__row left">
  <div class="layer_details__label">Down Tilt</div>
  <div class="layer_details__value">{{ verticalTilt }}°</div>
</div>
